export default "__VITE_ASSET__BGGRFNBV__"